export default "__VITE_ASSET__PyxJv3af__"